import React, {useEffect} from 'react';
import {connect, useSelector} from "react-redux";

// components
import LogHistoryList from "./_list";
import {getStateByPath} from "../../../redux/selectors";
import {showLoader} from "../../../components/loader/loader";

// actions
import {ADD_STATE, REMOVE_STATE} from "../../../redux/actions/generics/IndexedActions";

const LogHistory = props => {
    const path = 'monitor/logHistory';
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);


    return <>
        { loading && showLoader() }
        { componentState && <LogHistoryList path={path}/> }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
})

export default connect(mapStateToProps, mapActionsToProps)(LogHistory)